<template>
  <div>
    <transition name="fade">
      <div class="wim-menu-container">
        <!-- CREDITS -->
        <div v-if="credits === true" class="wim-credits-page">
          <div v-for="(section, menuIndex) in content" :key="menuIndex" v-if="menuIndex === 2" class="wim-credits-content tva-row"> 
              <div class="wim-credits-column tva-col-sm-offset-1 tva-col-sm-7">
                <span class="wim-credits-person" v-html="section.name1">{{section.name1}}</span>
                <span class="wim-credits-bio" v-html="section.bio1">{{section.bio1}}</span>
                <span class="wim-credits-person" v-html="section.name2">{{section.name2}}</span>
                <span class="wim-credits-bio" v-html="section.bio2">{{section.bio2}}</span>
              </div>
              <div class="wim-credits-column second tva-col-sm-3">
                <div class="wim-credits-description" v-html="section.description">{{section.description}}</div>
                
                <div class="wim-credits-title">{{section.title1}}</div>
                <a class="wim-credits-logo" href="https://thevisualagency.com/" target="_blank"><img :src="baseUrl +'images/'+section.logo+'.svg'" alt="image"></a>
                
                <div class="wim-credits-title">{{section.title2}}</div>
                <div class="wim-credits-list">
                  <span v-for="name in section.names" :key="name" v-html="name">{{name}}</span>
                </div>
              </div>
          </div>
        </div>
        <!-- close button -->
        <div class="wim-close-container">
          <div :class="['wim-close-button', credits ? 'credits' : '']" @click="onClick()">
            <div class="line-1"></div>
            <div class="line-2"></div>
          </div>
        </div>
        <!-- MENU CONTENT -->
        <div :class="['wim-project-name', credits ? 'credits' : '']">women in mining</div>
        <div class="wim-menu-content-wrapper" ref="carousel">
          <div v-for="(section, menuSectionIndex) in content" :key="menuSectionIndex" class="wim-menu-content">
            <div v-if="$mq === 'mobile'" class="wim-menu-title">{{section.title}}</div>
            <div v-if="$mq !== 'mobile' && menuSectionIndex !== 2" class="wim-menu-title">{{section.title}}</div>

            <div class="wim-menu-sections">
              <div v-if="$mq!== 'mobile' && menuSectionIndex !== 2" v-for="(element, index) in section.sections" :key="index" class="wim-menu-section" @click="goToSection(menuSectionIndex, index)" @mouseover="changeImage(menuSectionIndex, index)">{{element}}
                <div v-if="menuSectionIndex === 0" class="wim-menu-image">
                  <img v-if="imageIndex === index+1 && index !== 4" :src="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${imageIndex}_${element.toLowerCase() === 'women miners' ? 'minatrici' : element.toLowerCase()}/${imageIndex}_ritratto${$retina ? '@2x' : ''}.jpg`" :alt="element"/>
                  <img v-if="imageIndex === index+1 && index === 4" :src="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${imageIndex}_mama/${imageIndex}_ritratto${$retina ? '@2x' : ''}.jpg`" :alt="element"/>
                </div>
              </div>
              <!-- mobile -->
              <div class="wim-menu-mobile" v-if="$mq === 'mobile'">
                <!-- stories + focus -->
                <div class="wim-menu-section" v-if="menuSectionIndex === 0" @click="goToSection(menuSectionIndex, -1)">
                  <span :class="[sectionIndex <= 1 ? 'selected' : '' ]" >Intro</span>
                </div>
                <div v-for="(element, index) in section.sections" :key="index" class="wim-menu-section" @click="goToSection(menuSectionIndex, index)">
                  <span v-if="menuSectionIndex !== 2" :class="[index === sectionIndex-2 ? 'selected' : '' ]">{{element}}</span>
                </div>
                <!-- credits -->
                <div class="wim-mobile-credits" v-if="menuSectionIndex === 2">
                  <span class="wim-credits-person" v-html="section.name1">{{section.name1}}</span>
                  <span class="wim-credits-bio" v-html="section.bio1">{{section.bio1}}</span>
                  <span class="wim-credits-person" v-html="section.name2">{{section.name2}}</span>
                  <span class="wim-credits-bio" v-html="section.bio2">{{section.bio2}}</span>
                  <div class="wim-credits-description" v-html="section.description">{{section.description}}</div>

                  <div class="wim-credits-title">{{section.title1}}</div>
                  <a class="wim-credits-logo" href="https://thevisualagency.com/" target="_blank"><img :src="baseUrl +'images/'+section.logo+'.svg'" alt="image"></a>

                  <div class="wim-credits-title">{{section.title2}}</div>
                  <div class="wim-credits-list">
                    <span v-for="name in section.names" :key="name" v-html="name">{{name}}</span>
                  </div>
                </div>
             </div>
            </div>
          </div>
        </div>
        <div class="wim-credits-container">
          <div :class="['wim-credits-name', credits ? 'credits' : '']" @click="credits = !credits"><span v-if="!credits">credits</span><span v-if="credits">menu</span></div>
        </div>
        
        <div class="wim-navigation-container">
          <div
            v-for="(section, sectionIndex) in content"
            :key="sectionIndex"
            :class="['wim-navigation-section', selected === sectionIndex ? 'selected' : '']"
            @click="changeSection(sectionIndex)"
          >{{section.title}}</div>
        </div>
      </div>
      
    </transition>
  </div>
</template>
<script>
import VueScrollTo from 'vue-scrollto'
import Flickity from "flickity-imagesloaded"
import _ from "lodash"

export default {
  props: {
    content: Array,
    onClick: Function,
    sectionIndex: Number
  },
  data() {
    return {
      show: true, 
      selected: 0,
      credits: false,
      isFlickity: false,
      baseUrl: process.env.BASE_URL,
      imageIndex: 1
    };
  },
  mounted() {
    this.$nextTick(()=>{
      window.addEventListener("scroll", this.noscroll);

      this.createFlickity();
      window.addEventListener('resize', () => {
        this.createFlickity();
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.noscroll);
  },
  methods: {
    changeImage(sectionIndex, index){
      if(sectionIndex === 0){
        this.imageIndex = index+1;
      } else {
        this.imageIndex = 0;
      }
    },
    noscroll() {
      window.scrollTo(0, 0);
    },
    changeSection(index) {
      this.flkty.select(index);
      this.selected = index;
    },
    goToSection(sectionIndex, index) {
      if (sectionIndex === 0) {
        // Section
        this.onClick();
        VueScrollTo.scrollTo(`#wim-section-${index+1}`, 1);
      } else if (sectionIndex === 1) {
        // Focus
        this.$router.push(`/focus/${index}/${this.$ml.current}`)
      }
    },
    closeFocus() {
      this.onClick();
      VueScrollTo.scrollTo(`#wim-focus-preview-${this.focusContent.id}`, 1);
    },
    createFlickity() {
      var elem = this.$refs.carousel;
      const windowWidth = window.innerWidth;

      if (windowWidth <= 768) {
        if (!this.isFlickity) {
          this.flkty = new Flickity(elem, {
            cellAlign: "center",
            contain: true,
            draggable: false,
            prevNextButtons: false,
            pageDots: false,
            cellSelector: ".wim-menu-content"
          });
          this.flkty.on( 'change', (index) => {
            this.selected = index;
          });
          this.isFlickity = true;
        }
      } else {
        if (this.isFlickity) {
          this.flkty.destroy();
          this.flkty = null;
          this.isFlickity = false;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
img {
  background: transparent;
}
.wim-menu-container {
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  padding: 0% 7%;
  display:flex;
  flex-direction: column;
  align-items: center;
  z-index:40;
  .wim-credits-page {
    position:absolute;
    top:0;
    left:0;
    background: white;
    height: 100vh;
    width: 100vw;
    z-index:1;
    display: flex;
    align-items: center;
    justify-content: center;
    .wim-credits-content {
      z-index:2;
      display: flex;
      align-items: flex-start;
      height: 70vh;
      max-width: 1300px;
      overflow: auto;
      .wim-credits-column {
        &.second {
          padding-left: 40px !important;
        }
      }
      .wim-credits-description {
        font-family : 'Nunito Sans', sans-serif;
        font-weight : bold;
        font-size : 15px;
        line-height : 22px;
        letter-spacing : 0.38px;
        color : $beige;
      }
      .wim-credits-person,
      .wim-credits-title {
        font-family : 'Nunito Sans', sans-serif;
        font-weight : bold;
        font-size : 16px;
        line-height : 22px;
        letter-spacing : 0.4px;
        color: $red;
      }
      .wim-credits-list,
      .wim-credits-bio {
        font-family: 'Montserrat', sans-serif;
        font-size : 14px;
        line-height : 22px;
        font-weight: 300;
      }
      .wim-credits-title {
        margin-top: 3vh;
        margin-bottom: 10px;
      }
      .wim-credits-logo img {
        width: 100%;
      }
    }
  }
  .wim-close-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .wim-close-button {
      margin-top: 17px;
      cursor: pointer;
      height: 38px;
      padding-top: 7px;
      &.credits {
        z-index:1;
        .line-1, .line-2 {
          background: $red;
        }
      }
      .line-1 {
        width: 24px;
        height: 2px;
        transform: rotate(45deg) translateY(1px);
        transform-origin: 50%;
        background: white;
        transition: all 0.5s ease;
      }
      &:hover .line-1 {
        transform: rotate(-0deg) translateY(1px);
      }
      .line-2 {
        width: 24px;
        height: 2px;
        transform: rotate(-45deg) translateY(-1px);
        transform-origin: 50%;
        background: white;
        transition: all 0.5s ease;
      }
      &:hover .line-2 {
        transform: rotate(0deg) translateY(-1px);
      }
    }
  }
  .wim-credits-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1%;
    position: fixed;
    bottom: 0;
    left: 0;
    margin-bottom:10px;
    z-index: 1;
  }
  .wim-project-name,
  .wim-credits-name {
    font-family: "Nunito Sans", sans-serif;
    font-weight: 900;
    font-size: 14px;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    color: $white;
    user-select: none;
    &.credits {
      color: $red;
      z-index:1;
      &::after {
        border-bottom: solid 2px $red;
      }
    }
  }
  .wim-credits-name {
    cursor: pointer;
    position: relative;
    &::after {
      content: "";
      height: 3px;
      width: 0px;
      border-bottom: solid 2px $white;
      position: absolute;
      top: 15px;
      left: calc(50% - 10px);
      transition: all 0.5s ease;
    }
    &:hover::after {
      width: 20px;
    }
  }
  
  .wim-menu-content-wrapper {
    height: 100%;
    width: 100%;
    display:flex;
    flex-direction: column;
    justify-content: center; 
  }
  .wim-menu-content {
    margin-bottom: 50px;
    position: relative;
    .wim-menu-title {
      font-family: "Nunito Sans", sans-serif;
      font-weight: 800;
      font-size: 110px;
      line-height: 100px;
      text-transform: uppercase;
      color: $white;
      letter-spacing: 11px;
      margin-bottom: 10px;
      margin-top:10px;
      user-select: none;
    }
    .wim-menu-sections {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      max-width: 50%;
      .wim-menu-section {
        font-family: "Nunito Sans", sans-serif;
        font-weight: 400;
        font-size: 16px;
        color: $white;
        margin: 0 7px 7px 7px;
        white-space: nowrap;
        cursor: pointer;
        text-align: center;
        user-select: none;
        &:hover {
          color: $black;
        }
        &:not(:last-child)::after {
          content: "";
          width: 2px;
          height: 20px;
          border-right: solid 2px $white;
          margin-left: 10px;
        }
      }
    }
  }
  .wim-menu-image {
    position: absolute;
    top: 20%;
    right: 7%;
    width: 35%;
    height: 0;
    padding-bottom: 66.66%;
    overflow: hidden;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }
  .wim-navigation-container {
    display: none;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media (max-width: 768px) {
  .wim-menu-container {
    .wim-menu-content-wrapper {
      width: 100vw;
      justify-content: flex-start;
    }
    .wim-menu-content {
      width: 100%;
      z-index: 100;
      height: calc(100vh - 94px - 50px);
      overflow: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .wim-menu-title {
        font-size: 40px;
        margin-bottom: 5px;
        letter-spacing: 5px;
        text-align: center;
        // margin-top: 120px;
        line-height: 50px;
      }
      .wim-menu-sections {
        display: flex;
        flex-direction: column;
        align-items: center;
        .wim-menu-section {
          font-size: 16px;
          margin: 5px;
          cursor: pointer;
          span.selected {
            color: $black;
          }
          &:hover {
            color: $black;
          }
          &::after {
            display: none;
          }
        }
      }
    }
    .wim-menu-image {
      display: none;
    }
    .wim-close-container {
      padding-top:10px;
      padding-bottom: 10px;
    }
    .wim-project-name {
      text-align: center;
    }
    .wim-navigation-container {
      display: block;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50px;
      background: $black;
      display: flex;
      flex-direction: row;
      align-items: center;
      .wim-navigation-section {
        width: 50%;
        color: $white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: "Nunito Sans", sans-serif;
        font-weight: 900;
        font-size: 14px;
        letter-spacing: 1.4px;
        text-transform: uppercase;
        color: $white;
        &.selected {
          color: $red;
        }
      }
    }
    .wim-credits-container {
      z-index: 0;
    }
  }
  .wim-menu-mobile {
    text-align: center;
    // min-height: calc(93vh - 123px);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .wim-mobile-credits {
    overflow-y: scroll;
    padding: 0 25px;
    text-align: justify;
    height: calc(100vh - 200px);
    margin-bottom: 80px;
    .wim-credits-description {
      font-family : 'Nunito Sans', sans-serif;
      font-weight : bold;
      font-size : 14px;
      line-height : 22px;
      letter-spacing : 0.38px;
      color : $white;
      margin-top: 30px;
    }
    .wim-credits-person,
    .wim-credits-title {
      font-family : 'Nunito Sans', sans-serif;
      font-weight : bold;
      font-size : 16px;
      line-height : 22px;
      letter-spacing : 0.4px;
      color: $white;
      margin-top: 30px;
    }
    .wim-credits-list,
    .wim-credits-bio {
      font-family: 'Montserrat', sans-serif;
      font-size : 14px;
      line-height : 22px;
      font-weight: 300;
      color: $white;
    }
    .wim-credits-logo img {
      margin-top:10px;
      margin-bottom: 0;
    } 
  }
}
@media(max-width:1200px){
  .wim-menu-image {
    display:none;
  }
  .wim-menu-container {
    .wim-menu-content {
      .wim-menu-sections {
        max-width:100%;
      }
    }
  } 
}
</style>